import { render, staticRenderFns } from "./ShipmentDate.vue?vue&type=template&id=a63f11c4&scoped=true&"
import script from "./ShipmentDate.vue?vue&type=script&lang=ts&"
export * from "./ShipmentDate.vue?vue&type=script&lang=ts&"
import style0 from "./ShipmentDate.vue?vue&type=style&index=0&id=a63f11c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a63f11c4",
  null
  
)

export default component.exports